module.exports = __webpack_public_path__ + "img/kangaroo_pocket_width.e4166aca.png";